/* import __COLOCATED_TEMPLATE__ from './cx-distribution.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { CxBenchmarkGroup } from './types';

interface Signature {
  Args: {
    benchmarkGroup: CxBenchmarkGroup | undefined;
    industryLabel: string;
  };
}

export default class CxDistribution extends Component<Signature> {
  // TODO: Replace with real app CX score from the reporting data
  get appCxScore() {
    return 0.728;
  }

  get appCxScorePercent() {
    return `${(this.appCxScore * 100).toFixed(1)}%`;
  }

  // TODO: Compute from percentile interpolation once the density curve is built
  get percentileRank() {
    return 58;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::CxBenchmarkPanel::CxDistribution': typeof CxDistribution;
    'reporting/bespoke/fin-performance/cx-benchmark-panel/cx-distribution': typeof CxDistribution;
  }
}
